export enum Role {
    ADMIN = 'Leaf.Admin',
    USER = 'Leaf.User',
}
